import { createReducer, on } from '@ngrx/store';
import { setPremiumValueAction } from './premiumValue.actions';

export const initialState = 0;

export const premiumValueReducer = createReducer(
  initialState,
  on(setPremiumValueAction, (state, { premiumValue }) => premiumValue)
);